import type { AxiosResponse } from '@/lib/api/auth';
import { GetMaxBet } from '@/lib/api/bets';
import { logger } from '@/lib/api/logger';
import { mobx } from '@/lib/mobx';

interface GetMaxBetProps {
  queryString: string;
  setIsLoading: (isLoading: boolean) => void;
}

export async function getMaxBet({
  queryString = '',
  setIsLoading = () => {},
}: GetMaxBetProps): Promise<number | null> {
  setIsLoading(true);

  if (mobx.profile.isGuest) {
    // maybe that's not the best place to check this condition however it's
    // risky to rely that this check will be added in every place where this function
    // is used. Luckily we have a `null` response which we may use to skip logic for guests
    setIsLoading(false);
    return null;
  }

  try {
    const {
      data: {
        data: { amount },
      },
    }: AxiosResponse<{ data: { amount: number; currency: string } }> = await GetMaxBet(queryString);

    return amount;
  } catch (error) {
    logger.error('Error in getCurrentMaxBet.js', {
      error: error as Error,
      queryString,
    });
    return null;
  } finally {
    setIsLoading(false);
  }
}
